import CancelablePromise, { cancelable } from 'cancelable-promise';

class PromisePool {
    getFreeId() {
        let id = 0; // NOTE: Mindig elsőnek a 0-át nézzük meg
        while(this.pool.has(id)){
            id = Math.random();
        }
        return id;
    }
    add(promise) {
        const id = this.getFreeId();
        const cancelablePromise = "cancel" in promise ? promise : cancelable(promise);
        this.pool.set(id, cancelablePromise);
        return cancelablePromise.finally(()=>{
            this.pool.delete(id);
        }, true);
    }
    addTimeout(ms = 2000) {
        const cancelablePromise = new CancelablePromise((resolve)=>{
            setTimeout(resolve, ms);
        });
        return this.add(cancelablePromise);
    }
    addInterval(ms) {
        return {
            then: (cb)=>{
                this.addTimeout(ms).then(()=>{
                    cb();
                    this.addInterval(ms).then(cb);
                });
            }
        };
    }
    cancel() {
        this.pool.forEach((cancelablePromise)=>cancelablePromise.cancel());
        this.pool.clear();
    }
    constructor(){
        this.pool = new Map();
    }
}

export { PromisePool };
//# sourceMappingURL=promise-pool.js.map
